import React from "react";
import PropTypes from "prop-types";
import ArrowWhite from "../Shared/icons/ArrowWhite";

function SuggestionItem({label, onClick}) {
    return (
        <div className="suggest-dropdown__item" onClick={onClick}>
            <div className="suggest-dropdown__item-name">
                <span dangerouslySetInnerHTML={{__html: label}}/>
            </div>
            <ArrowWhite fill="#003a67"/>
        </div>
    );
}

SuggestionItem.propTypes = {
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
};

export default SuggestionItem;